import React from 'react';

const LoadingIcon = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10" fill="none">
            <rect width="10" height="10" rx="1.5" fill="white" />
        </svg>
    );
};

export default LoadingIcon;
